import { Card as MuiCard, styled } from '@mui/material';

export const Card = styled(MuiCard)({
  border: '1px solid #D9D9D9',
  backgroundColor: '#FFFFFF',
  borderRadius: 8,
  boxShadow: 'none',
  marginBottom: 16,
  color: '#000',
  '& .MuiCardContent-root': {
    padding: 16,
    fontSize: 14,
    fontWeight: 400
  },
  '& a': {
    textDecoration: 'underline',
    color: '#0675DD'
  },
  '& .MuiGrid-container': {
    marginBottom: 12
  },
  '& .status-wrapper': {
    alignItems: 'flex-start'
  },
  '& .status-text': {
    color: '#0675DD',
    textDecoration: 'none',
    fontWeight: 400,
    fontSize: 14
  },
  '.MuiCardActions-root': {
    justifyContent: 'flex-end',
  }
});

export const CardTitle = styled('h3')({
  fontWeight: 700,
  fontSize: 18,
  margin: '0px 0px 16px 0px',
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  span: {
    display: 'flex',
    alignItems: 'center',
    span: {
      marginLeft: 8
    }
  },
  '& .MuiSvgIcon-root': {
    width: 12,
    height: 12
  },
  '&.hr': {
    borderBottom: '1px solid #E9EAEE',
    paddingBottom: 16
  },
  '&.clickable': {
    cursor: 'pointer'
  }
});
